import React from "react";
import styled from "styled-components";
import {
  AuctionText,
  AuctionTextWrapper,
  CollectionDropdownWrapper,
  CollectionGridNftContainer,
  CollectionGridWrapper,
  CollectionImage,
  CollectionImageWrapper,
  CollectionNftPrice,
  CollectionNftText,
  CollectionNftTextWrapper,
  CollectionWithDropdornCOntainer,
} from "./DashboardCoinholdingstyled";
import DropdownComponent from "./DropdownComponent";
import CarNft1 from "../../Images/VehicalNft1.png";
import SkinNft1 from "../../Images/SkinNft1.png";
import SkinNft2 from "../../Images/SkinNft2.png";
import GunNft1 from "../../Images/GunNft1.png";

export const Root = styled.div`
  margin: 25px 15px;
`;
export const Container = styled.div`
  padding: 0 15px;
`;

const RecentCollection = () => {
  return (
    <Root>
      <Container>
        <CollectionWithDropdornCOntainer>
          <AuctionTextWrapper>
            <AuctionText>Recent Collection</AuctionText>
          </AuctionTextWrapper>
          <CollectionDropdownWrapper>
            <DropdownComponent />
          </CollectionDropdownWrapper>
        </CollectionWithDropdornCOntainer>

        <CollectionGridNftContainer>
          <CollectionGridWrapper>
            <CollectionImageWrapper>
              <CollectionImage src={CarNft1}/>
            </CollectionImageWrapper>
          <CollectionNftTextWrapper>
          <CollectionNftText>
          Nft : VEHICLE
          </CollectionNftText>
          <CollectionNftPrice>
          Floor : 10MLD ~ 100USD 
          </CollectionNftPrice>
          </CollectionNftTextWrapper>
          </CollectionGridWrapper>


          <CollectionGridWrapper>
            <CollectionImageWrapper>
              <CollectionImage src={SkinNft1}/>
            </CollectionImageWrapper>
          <CollectionNftTextWrapper>
          <CollectionNftText>
          Nft : SKIN
          </CollectionNftText>
          <CollectionNftPrice>
          Floor : 10MLD ~ 110USD 
          </CollectionNftPrice>
          </CollectionNftTextWrapper>
          </CollectionGridWrapper>



          <CollectionGridWrapper>
            <CollectionImageWrapper>
              <CollectionImage src={SkinNft2}/>
            </CollectionImageWrapper>
          <CollectionNftTextWrapper>
          <CollectionNftText>
          Nft : SKIN
          </CollectionNftText>
          <CollectionNftPrice>
          Floor : 10MLD ~ 90USD 
          </CollectionNftPrice>
          </CollectionNftTextWrapper>
          </CollectionGridWrapper>



          <CollectionGridWrapper>
            <CollectionImageWrapper>
              <CollectionImage src={GunNft1}/>
            </CollectionImageWrapper>
          <CollectionNftTextWrapper>
          <CollectionNftText>
          Nft : GUN
          </CollectionNftText>
          <CollectionNftPrice>
          Floor : 10MLD ~ 170USD 
          </CollectionNftPrice>
          </CollectionNftTextWrapper>
          </CollectionGridWrapper>
        </CollectionGridNftContainer>
      </Container>
    </Root>
  );
};

export default RecentCollection;
